import React from 'react';
import HeaderSection from './Header';
import Footer from '../components/Footer';
import PageHeading from '../components/PageHeading';
import data from './data';
const rowData = [
  { pic: './public/images/about-inner.jpg',
    text: 'The year of inception – 1997. Founding Partners CA Dharmendra\
           Chachan & CA Naresh Lath (in association for the last 33 years).\
           Developed fiduciary relationship with sound corporates and businesses.\
           Established core competencies and knowledge base. Well equipped and furnished\
           office premises in Delhi . State of the art IT infrastructure. \
           Empanelled with RBI & CAG. Founding partners are qualified Information System\
           Auditors.The Firm has a rich experience in Internal, Statutory & Management\
           Audits of SME sector. Beside audits, direct & indirect taxation is one of the\
           firms core competencies. We serve a wide array of clients, ranging from individuals\
           to corporates.'
  },
  { pic: './public/images/about-inner.jpg',
    text: 'We have a diversified portfolio of clients which include Electrical Appliances,\
           Embrodieries & Clothing, Banking, Automobile Components, Exhibitions & Display products,\
           Share Broking, Seed Fund, Construction etc. The Firm has a rich experience in Internal,\
           Statutory & Management Audits of SME sector. Beside audits, direct & indirect taxation is\
           one of the firms core competencies. We serve a wide array of clients, ranging from individuals\
           to corporates.Legal advisory and statutory compliance is also a part and parcel of the\
           firms practice. In addition the firm excels in conducting due diligence, detailed vetting \
           of legal documents, and preparation of US tax returns for American citizens and NRIs.'
  }
];
const Card = ({pic, items}) => (
  <section className="about-card column large-12 medium-expanded small-12">
    <article className="about-card__wrapper">
      <ul className=" text-justify about-card__text">
        {items.map((item, index) => <li key={index}>{item}</li>)}
      </ul>
    </article>
  </section>
);
const RowCard = ({pic, text}) => (
  <section className="about-card column large-12 medium-expanded small-12">
    <article className="card-wrapper about-row-card__wrapper">
      <figure>
        <img src={pic} className="about-row-card__image" />
      </figure>
      <span className="text-justify about-row-card__content">
        {text}
      </span>
    </article>
  </section>

);
const AboutPage = () => (
  <main className="about-page">
    <HeaderSection />
    <section>
      <article className="section-about_background-image">
        <PageHeading
          text1='About '
          text2='Us '
          text3=''
        />
      </article>
      <article className="section__content">
        <header>
          <h2 className="text-center margin-bottom-default">Who we are ?</h2>
        </header>
        <section className="row align-spaced">
          <RowCard {...rowData[0]}/>
        </section>
      </article>
      <article className="section-about__background-image">
        <header>
          <h2 className="text-center section-about__heading">Why Choose us</h2>
        </header>
        <section className="row align-spaced section__content">
          {data.map((item, index) =>
           <Card key={index} {...item} />
          )}
        </section>
      </article>
      <article className="section__content">
        <header>
          <h2 className="text-center margin-bottom-default">FIRM EXPERIENCE</h2>
        </header>
        <section className="row align-spaced">
          <RowCard {...rowData[1]}/>
        </section>
      </article>
    </section>
    <Footer />
  </main>
);
export default AboutPage;



// WEBPACK FOOTER //
// ./src/AboutPage/index.js